import InputField from './input-field';

export default InputField;